import {useQuery} from '@tanstack/react-query';
import {apiClient} from '@common/http/query-client';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import {ShopProduct} from '../product';

interface FetchProductsResponse extends BackendResponse {
  products: ShopProduct[];
}

export function useProducts() {
  return useQuery({
    queryKey: ['shop-products'],
    queryFn: () => fetchProducts(),
  });
}

async function fetchProducts(): Promise<FetchProductsResponse> {
  // Generate a token first
  const tokenResponse = await apiClient.post('drive/generate-token', {
    endpoint_type: 'products',
  });
  
  const token = tokenResponse.data.token;
  
  // Call external API with token
  const response = await fetch('https://apcrosa.syscomlive.co.uk/api/v1/drive/products/get-all', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-API-Token': token,
    },
  });

  if (!response.ok) {
    throw new Error('Failed to fetch products');
  }

  const data = await response.json();
  
  if (data.status !== 1) {
    throw new Error(data.msg || 'Failed to fetch products');
  }

  return {
    products: data.products || [],
  };
}
